import React from "react";
import finlandBg from "../assets/img/finlandbg.jpg";
import finland from "../assets/flags/finland.png"
import FinComponent from "./FinComponent";

type Props = {};

const Finland = (props: Props) => {
  return (
    <>
      <div id="#customcontainer" className="customcontainer mt-4 pt-3">
        <div
          className="bg-image d-flex justify-content-center mt-5 align-items-center"
          style={{
            backgroundImage: `url(${finlandBg})`,
            height: "500px",
            backgroundSize: "cover",
            backgroundPosition: "top",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backgroundBlendMode: "overlay",
          }}
        >
          <div className="row landingformlayout w-100 mx-0 px-5 mt-5">
            <div className="col-md-8 ieltslandingcontent">
              <h1 className="bannerHeading text-light">
                Why Study In Finland ?
              </h1>
              <ul className="bannerPoints text-dark">
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Worldwide recognition
                  for outstanding academic achievements
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> A diverse and
                  multicultural populace
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Students get utmost
                  learning opportunities.
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Exceptional living
                  standards
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> An environment
                  characterized by safety and security
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Top-notch educational
                  offerings
                </li>
              </ul>
              <img
                src={finland}
                className="mt-2 mx-4"
                style={{ width: "80px" }}
              />
            </div>

            <div
              className="ieltslandingcontentmobile"
              style={{ display: "none" }}
            >
              <h1 className="bannerHeading text-light">
                Why to Study in Finland ?
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="section-head col-sm-12 mb-1 mt-3">
          <h4>
            <span>Finland</span>
          </h4>
        </div>
        <FinComponent />
      </div>


    </>
  );
};

export default Finland;
